import api from '../lib/api';

export const FETCH_ALL_ZONES = 'FETCH_ALL_ZONES';
export const FETCH_MARKET_ZONES = 'FETCH_MARKET_ZONES';
export const ZONES_LOADING = 'ZONES_LOADING';

export default {
  fetchZones(query) {
    return (dispatch) => {
      dispatch({ type: ZONES_LOADING, payload: true });

      return api.getZones(query)
        .then((zones) => {
          if (query) {
            dispatch({ type: FETCH_MARKET_ZONES, payload: zones });
          } else {
            dispatch({ type: FETCH_ALL_ZONES, payload: zones });
          }
        })
        .then(() => {
          dispatch({ type: ZONES_LOADING, payload: false });
        })
        .catch(() => {
          dispatch({ type: ZONES_LOADING, payload: false });
        });
    };
  },
  createZone(zone) {
    return () => api.createZone(zone);
  },
  updateZone(zone, zoneId) {
    return () => api.updateZone(zone, zoneId);
  },
  updateMultipleZones(data) {
    return () => api.updateMultipleZones(data);
  },
};
